const context = 'configuration'

export const FETCH_CONFIGURATIONS = `${context}/FETCH_CONFIGURATIONS`
export const DELETE_CONFIGURATION = `${context}/DELETE_CONFIGURATION`
export const UPDATE_CONFIGURATION = `${context}/UPDATE_CONFIGURATION`
export const CREATE_CONFIGURATION = `${context}/CREATE_CONFIGURATION`

export const SET_CONFIGURATIONS_FILTER = `${context}/SET_CONFIGURATIONS_FILTER`
